// extracted by mini-css-extract-plugin
export default {"description":"Finish_description__929oa"};